(function ($) {
    'use strict';

    $(function () {
        $('section.media_slider .media-slider-swiper').each(function () {
            var swiperEl = this;
            if (swiperEl.dataset.swiperInitialized === '1') {
                return;
            }
            var wrap = swiperEl.closest('.media-slider-swiper-wrap');
            if (!wrap) {
                return;
            }
            var prev = wrap.querySelector('.swiper-button-prev--media-slider');
            var next = wrap.querySelector('.swiper-button-next--media-slider');
            var caption = wrap.nextElementSibling && wrap.nextElementSibling.classList.contains('media-slider-caption')
                ? wrap.nextElementSibling
                : null;
            var captionTitle = caption ? caption.querySelector('.media-slider-caption__title') : null;
            var captionTimer = null;

            function setCaption(index, immediate) {
                if (!caption || !captionTitle || !swiper.slides[index]) {
                    return;
                }

                var title = swiper.slides[index].dataset.slideTitle || '';

                window.clearTimeout(captionTimer);

                if (immediate) {
                    captionTitle.textContent = title;
                    caption.classList.toggle('is-empty', title === '');
                    caption.classList.remove('is-fading');
                    return;
                }

                caption.classList.add('is-fading');
                captionTimer = window.setTimeout(function () {
                    captionTitle.textContent = title;
                    caption.classList.toggle('is-empty', title === '');
                    caption.classList.remove('is-fading');
                }, 180);
            }

            swiperEl.dataset.swiperInitialized = '1';

            var swiper = new Swiper(swiperEl, {
                slidesPerView: 1,
                speed: 500,
                spaceBetween: 0,
                watchOverflow: true,
                navigation: {
                    prevEl: prev,
                    nextEl: next,
                    addIcons: false,
                },
            });

            setCaption(swiper.activeIndex, true);

            swiper.on('slideChangeTransitionStart', function () {
                setCaption(swiper.activeIndex, false);
            });

            swiper.on('slideChangeTransitionEnd', function () {
                var pause = window.FlutterbeeVideo && typeof window.FlutterbeeVideo.pauseEmbeddedMedia === 'function'
                    ? window.FlutterbeeVideo.pauseEmbeddedMedia
                    : null;
                if (!pause) {
                    return;
                }
                swiper.slides.forEach(function (slide, idx) {
                    if (idx !== swiper.activeIndex) {
                        pause(slide);
                    }
                });
            });
        });
    });
})(jQuery);
